import { Component, Input } from "@angular/core";
import { FilingService } from "../../../../api/services/filing.service";
import { FormFilter } from "../../../../api/models/form-filter";
import { FormState } from "../../../../api/models/form-state";
import { Form } from "../../../../api/models/form";
import { ConfirmationService, MessageService } from "primeng/api";
import {Filing, FormType, ManualFiling, MultiDiscard} from "../../../../api/models";
import { DiscardConfirmationComponent } from "../modals/discard-confirmation/discard-confirmation.component";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import MANUAL_CHECK = FormState.MANUAL_CHECK;
import { PreviousFilingIdService } from "src/core/services/shared/filingId.service";
import { NgForm } from "@angular/forms";
import { handlePasteWithoutLeadingSpaces, preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
import {ManualFilingService} from "../../../../api/services/manual-filing.service";

@Component({
  selector: "app-manual",
  templateUrl: "./manual.component.html",
  styleUrl: "./manual.component.css",
  standalone: false,

})
export class ManualComponent {
  filings: Form[] = [];
  filing: Filing = {};
  selectedProducts: any[] = []; // To store selected rows
  first = 0;
  selectedFiling: any[] = [];
  isLoading: boolean = false;
  rows = 10;
  displayAddModal = false;
  displayLLMBackupModal = false;
  displayProcessedBackupModal = false;
  formTypes = FormType.values();
  selectedFormType: FormType | undefined;
 @Input() filingIdInput?:  number;
  issuerNameInput?: string;
  selectedBackup: any = null;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  thisUser = "";
  ref!: DynamicDialogRef;
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  showManualFilingDialog = false;
  isSubmittingManualFiling = false;

  manualFiling: ManualFiling = {
    companyName: '',
    filingDate: '',
    sourceUrl: '',
    text: ''
  };

  constructor(
    private _filingService: FilingService,
    private previousFilingIdService: PreviousFilingIdService,
    private _messageService: MessageService,
    private _confirmationService: ConfirmationService,
    public dialogService: DialogService,
    private manualFilingService: ManualFilingService
  ) {
    const email = localStorage.getItem("email");
    if (email) this.thisUser = email;
  }

  ngOnInit(): void {
    // this.getFilingWithFilingFilter();
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  openAddModal(filing: Form) {
    if (filing.filingId !== undefined) {
      this.previousFilingIdService.setPreviousFiling(
        filing.filingId.toString(),
        "MANUAL_CHECK"
      );
    }
    this.selectedBackup = filing;
    this.getFilingWithFilingId(filing.filingId);
  }

  openLLMBackupModal(product: any, event: Event) {
    event.preventDefault();
    this.selectedBackup = product;
    this.displayLLMBackupModal = true;
  }

  openProcessedBackupModal(product: any, event: Event) {
    event.preventDefault();
    this.selectedBackup = product;
    this.displayProcessedBackupModal = true;
  }

  onDialogHide(event: any) {
    // Clear the selected products when dialog is closed
    this.displayAddModal = event;
  }

 onSearch(form?: NgForm) {

  if (form && form.invalid) {
    form.control.markAllAsTouched();
    return;
  }

  this.first = 0;
  this.paginator.pageNumber = 1;
  this.getFilingWithFilingFilter();
}


  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)

      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);

      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingWithFilingFilter();
  }

  getFilingWithFilingFilter() {
    const cleanedIssuerName =
    typeof this.issuerNameInput === 'string'
      ? this.issuerNameInput.trim()
      : this.issuerNameInput;

    const params: FormFilter = {
      formState: MANUAL_CHECK,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      formType: this.selectedFormType,
      filingId: this.filingIdInput,
      issuerName: cleanedIssuerName,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this._filingService.getFilings(params).subscribe({
      next: (value) => {
        this.filings = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.filings.length > 0 ? this.filings[0].totalCount! : 0;
        this.isLoading = false;
      },
    });
  }

  getFilingWithFilingId(filingId: any) {
    this.isLoading = true;
    let result = true;
    this._filingService.lockFiling({ filingId: filingId }).subscribe({
      next: (value) => {
        result = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        if (!result) return;
        this._filingService.getFilingByFilingId(filingId).subscribe({
          next: (value) => {
            this.filing = value;
          },
          error: (err) => {
            this.isLoading = false;
            this._messageService.add({
              summary: err.error.message,
              severity: "error",
            });
          },
          complete: () => {
            this.isLoading = false;
            this.displayAddModal = true;
          },
        });
      },
    });
  }

  lockFile(filing: any) {
    let result = true;
    this._filingService.lockFiling({ filingId: filing.filingId }).subscribe({
      next: (value) => {
        result = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        if (result) this.getFilingWithFilingFilter();
      },
    });
  }

  unlockFileFromValidateForm(filingId: any) {
    this.isLoading = true;
    this._filingService.unlockFiling(filingId).subscribe({
      next: (value) => {},
      error: (err) => {
        if (err.status === 409) {
          // Handle 409 Conflict specifically
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "warn", // or "error" if appropriate
          });
        } else {
          // Handle other errors
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "error",
          });
        }
      },
      complete: () => {
        this.getFilingWithFilingFilter();
      },
    });
  }

  unlockFile(filing: any) {
    this.isLoading = true;
    this._filingService.unlockFiling(filing.filingId).subscribe({
      next: (value) => {},
      error: (err) => {
        if (err.status === 409) {
          // Handle 409 Conflict specifically
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "warn", // or "error" if appropriate
          });
        } else {
          // Handle other errors
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "error",
          });
        }
      },
      complete: () => {
        this.getFilingWithFilingFilter();
      },
    });
  }

  confirmUnlock(filing: any) {
    if (filing.lockedBy == this.thisUser) {
      this._confirmationService.confirm({
        message: `This filing is locked by you. Do you want to unlock it?`,
        header: "Unlock Confirmation",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "No",
        accept: () => {
          this.unlockFile(filing);
        },
      });
      return;
    }
    this._confirmationService.confirm({
      message: `This filing is locked by ${filing.lockedBy}. Do you want to force unlock and edit it?`,
      header: "Unlock Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.lockFileByForce(filing);
      },
    });
  }

  lockFileByForce(filing: any) {
    this._filingService
      .lockFiling({ filingId: filing.filingId, isForceLock: true })
      .subscribe({
        next: (value) => {
          if (value) this.getFilingWithFilingFilter();
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            summary: err.error.message,
            severity: "error",
          });
        },
        complete: () => {},
      });
  }

  discardFiling(filing: any): void {
    // this.ref = this.dialogService.open(DiscardConfirmationComponent, {
    //   width: "30vw",
    //   data: { filing },
    //   dismissableMask: false,
    //   closable: true,
    //   modal: true,
    // });
    //
    // this.ref.onClose.subscribe((data) => {
    //   if (data?.reason) {
    this._filingService
      .discardFiling({
        filingId: filing.filingId,
        reason: "no plan found",
      })
      .subscribe({
        next: () => {
          this._messageService.add({
            severity: "success",
            summary: "Discarded",
            detail: `Filing #${filing.filingId} discarded successfully.`,
          });
          this.getFilingWithFilingFilter();
        },
        error: (err) => {
          this._messageService.add({
            severity: "error",
            summary: "Error",
            detail: err?.error?.message || "Failed to discard filing.",
          });
        },
      });
    //   }
    // });
  }
  onGroupDiscardClick() {
    const discardIds = this.selectedFiling
      .filter((filing) => filing.filingId !== undefined)
      .map((filing) => filing.filingId);
    const submission: MultiDiscard = {
      ids: discardIds,
      reason: "no plan found",
    };

    this._filingService.multiDiscardFiling(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been discarded successfully.",
        });
        this.selectedFiling = [];
        this.getFilingWithFilingFilter();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
  shouldDisableRowAction(record: any): boolean {
    // Add your logic here, e.g., disable if it's in selectedFiling
    return this.selectedFiling.includes(record);
  }


  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

onPaste(
  event: ClipboardEvent,
  field: "issuerNameInput" | "filingIdInput"
): void {
  handlePasteWithoutLeadingSpaces(event, (newValue: string) => {

    if (field === "issuerNameInput") {
      this.issuerNameInput = newValue.trim() || undefined;
      return;
    }

    if (field === "filingIdInput") {
      const num = Number(newValue.trim());
      this.filingIdInput = Number.isNaN(num) ? undefined : num;
    }

  });
}

  openManualFilingForm(): void {
    this.manualFiling = {
      companyName: '',
      filingDate: '',
      sourceUrl: '',
      text: ''
    };

    this.showManualFilingDialog = true;
  }

  closeManualFilingForm(): void {
    this.showManualFilingDialog = false;
  }

  submitManualFiling(form: NgForm): void {
    if (form.invalid) {
      form.control.markAllAsTouched();
      return;
    }

    this.isSubmittingManualFiling = true;
    console.log('test', this.manualFiling);
    this.manualFilingService.addManualFiling(this.manualFiling)
      .subscribe({
        next: (response) => {
          this._messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Manual filing added successfully."
          });

          this.showManualFilingDialog = false;
          this.isSubmittingManualFiling = false;
        },

        error: (err) => {
          this.isSubmittingManualFiling = false;

          this._messageService.add({
            severity: "error",
            summary: "Error",
            detail:
              err?.error?.message || "Failed to add manual filing."
          });
        }
      });
  }


}
